import { render } from "./LoginPage.vue?vue&type=template&id=4ed4f891&ts=true"
import script from "./LoginPage.vue?vue&type=script&lang=ts"
export * from "./LoginPage.vue?vue&type=script&lang=ts"

import "./LoginPage.vue?vue&type=style&index=0&id=4ed4f891&lang=scss"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/CDC/Dashboard/Dashboard_CDC_FE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__